import {default as Controller} from './AccountManagementControl'
import {showModalPopup} from '../../redux/actions'
import {connect} from 'react-redux'
import {MODAL_POPUP_ID} from '../../redux/const'

const AccountManagementControl = connect(
    (state) => ({
        visible: state.login.isLoggedIn
    }),
    (dispatch) => ({
        click: () => {
            dispatch(showModalPopup(MODAL_POPUP_ID.ACCOUNT_MANAGEMENT))
        }
    })
)(Controller)

AccountManagementControl.defaultProps = {
    visible: null,
    click: null,
}

export default AccountManagementControl


// WEBPACK FOOTER //
// ./src/components/AccountManagementControl/index.js